export const emptyDataGetTotalSalesV2 = {
  hasCaas: false,
  hasEffectiveMaasSales: false,
  totalValues: {
    totalStudents: 0,
    totalValue: 0,
    receivedValue: 0,
    receiveTotalValue: 0,
  },
  educationalCredit: {
    totalStudents: 0,
    totalValue: 0,
    receivedValue: 0,
    receiveTotalValue: 0,
  },
  maas: {
    totalStudents: 0,
    totalValue: 0,
    receivedValue: 0,
    receiveTotalValue: 0,
  },
  caas: {
    totalStudents: 0,
    totalValue: 0,
    receivedValue: 0,
    receiveTotalValue: 0,
  },
  provipay: {
    totalCountValue: 0,
    totalCountBoleto: 0,
    totalCountCreditCard: 0,
    totalCountPix: 0,
    totalValue: 0,
    totalValueBoleto: 0,
    totalValueCreditCard: 0,
    totalValuePix: 0,
  },
};
